// Global Instructions Rule Applied!

export const SET_INTERACTIONS = 'interactions/SET_INTERACTIONS' as const
export const UPDATE_INTERACTION = 'interactions/UPDATE_INTERACTION' as const
export const ADD_INTERACTION = 'interactions/ADD_INTERACTION' as const
export const REMOVE_INTERACTION = 'interactions/REMOVE_INTERACTION' as const
export const CLEAR_INTERACTIONS = 'interactions/CLEAR_INTERACTIONS' as const
